import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure58 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        height: '1000px',
        type: 'bar',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#4472c4', '#a5a5a5', '#5b9bd5'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: true,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },
  
  
      xAxis: [{
        categories: [
		     "Monde",
		     "Amérique du Nord et Europe",
		     "Amérique latine et Caraïbes ",
		     "Asie de l’Ouest et Afrique du Nord",
		     "Afrique subsaharienne",
		     "Asie centrale et du Sud",
		     "Petits États insulaires en développement",
		     "Australie et Nouvelle-Zélande",
		     "Asie de l’Est et Asie du Sud-Est",
		     "Pays les moins avancés",
		     "Océanie hors Australie et Nouvelle-Zélande",
        ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          format: '',
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 2,
        min: 0.0,
        tickInterval: 0.5,
        gridLineWidth: 2,
        title: {
          text: null,
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: '2011',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
		      enabled: false,
		      format: '{point.y:,.2f}',

          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
  
        },
        data: [0.10, 
          0.3, 
          0.12, 
          0.18, 
          0.27, 
          0.24, 
          0.48,
          0.50,
          1.5,
          1.26,
          1.70
        ]
      },{
        name: '2015',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
		      enabled: false,
		      format: '{point.y:,.2f}',

          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
  
        },
        data: [0.10, 
          0.2, 
          0.7, 
          0.23, 
          0.42, 
          0.24, 
          0.49,
          0.57,
          0.91,
          1.24,
          1.62,
        ]
      },{
        name: '2019',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
		      enabled: false,
		      format: '{point.y:,.2f}',
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
  
        },
        data: [0.9, 
          0.2, 
          0.8, 
          0.22, 
          0.38, 
          0.20, 
          0.45,
          0.51,
          0.79,
          0.88,
          1.5417,]
      },
    ]

}
